import { useIdentity } from "base/identity-resolver";
import { useEffect, useState } from "react";
import { fetchJourneysWithDueDatesForGroup } from "apps/journeys/utils/api-requests/journey-index";
import useHomePage from "apps/home/hooks/use-home-page";
import useJourneyGroups from "apps/journeys/hooks/use-journey-groups";
import HomepageMainContent from "../components/homepage-main-content";
import useJourneyTimeoutsApi from "apps/journeys/hooks/use-journey-timeouts-api";
import useTripsAndMeetings from "../hooks/use-trips-meetings";

const today = new Date();
const HomepageController = () => {
  const { user = {} } = useIdentity();
  const { journeyGroups, setSelectedJourneyGroup, selectedJourneyGroup } = useJourneyGroups();
  const { todayTaskCount, addTaskToCount, nextFiveDaysCounts } = useHomePage(selectedJourneyGroup);
  const { businessDaysUntilFutureTimeout, futureJourneyTimeout, inProgressJourneyTimeout } = useJourneyTimeoutsApi();
  const { tripsAndMeetingDetails, tripsAndMeetingDetailsForNextFive } = useTripsAndMeetings(user.id);
  const [journeys, setJourneys] = useState([]);

  useEffect(() => {
    const getAndSetJourneys = async () => {
      const journeysListResponse = await fetchJourneysWithDueDatesForGroup(
        selectedJourneyGroup.id,
        user.id,
        ["IN_PROGRESS"],
        today.getTime()
      );
      setJourneys(journeysListResponse);
    };
    getAndSetJourneys();
  }, [user.id, selectedJourneyGroup.id]);

  const optionalStateManagementFunction = (type, args = {}) => {
    switch (type) {
      case "addTask":
        addTaskToCount(args.task);
        break;
      default:
        break;
    }
  };

  return (
    <HomepageMainContent
      user={user}
      journeys={journeys}
      journeyGroups={journeyGroups}
      todayTaskCount={todayTaskCount}
      nextFiveDaysCounts={nextFiveDaysCounts}
      futureJourneyTimeout={futureJourneyTimeout}
      selectedJourneyGroup={selectedJourneyGroup}
      setSelectedJourneyGroup={setSelectedJourneyGroup}
      inProgressJourneyTimeout={inProgressJourneyTimeout}
      businessDaysUntilFutureTimeout={businessDaysUntilFutureTimeout}
      tripsAndMeetingDetails={tripsAndMeetingDetails}
      tripsAndMeetingDetailsForNextFive={tripsAndMeetingDetailsForNextFive}
      optionalStateManagementFunction={optionalStateManagementFunction}
    />
  );
};

export default HomepageController;
